import { environment as baseEnvironment } from '../../../shared/src/environments/environment';

export const environment = Object.assign(baseEnvironment, {
  cmsWebAppUrl: 'https://localhost:4200/',
  cmsServerUrl: 'https://localhost:5001/api/',
  idpServerUrl: 'https://localhost:5003/',
  loginClientId: '27a8f1e0-93a0-406d-a745-d0db83e89038'
});
